import { sharedEnvironment } from "@grainger/angular/environment/shared-environment";
import { AngularEnvironment } from "@grainger/common/definitions/environment";

export const baseEnvironemnt: AngularEnvironment = {
    ...sharedEnvironment,
    production: false,
    gaId: window.location.origin.includes("graingerroadmaps.com") ? "G-9HGX7TTSMZ" : "G-S30WMY57X3"
};
